<template>
  <div>
    <alert
      :visible="!!alert_message"
      dark
      :type="type_alert"
      :message="alert_message"
      :clickClose="() => (alert_message = '')"
    />
    <v-data-table
      :headers="headers"
      :loading="loading"
      :items="observations"
      :search="search"
      sort-by="id"
      class="elevation-1"
    >
      <template v-slot:top>
        <v-toolbar flat>
          <v-toolbar-title>OBSERVAÇÕES DO PEDIDO</v-toolbar-title>
          <v-divider class="mx-4" inset vertical></v-divider>
          <v-spacer></v-spacer>
          <v-spacer></v-spacer>
          <v-text-field
            v-model="search"
            append-icon="mdi-magnify"
            label="Busca"
            single-line
            hide-details
          ></v-text-field>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" dark @click="addObservation()">
            <v-icon left>mdi-plus</v-icon>
            Novo
          </v-btn>
          <v-dialog v-model="dialogDelete" max-width="500px">
            <v-card>
              <v-toolbar color="red lighten-1" dark class="text-h5"
                >Atenção</v-toolbar
              >
              <v-card-title class="text-h6">
                Tem certeza que deseja Deletar?
              </v-card-title>
              <v-divider></v-divider>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="blue darken-1" text @click="closeDelete()"
                  >Fechar</v-btn
                >
                <v-btn color="red darken-1" dark @click="deleteItemConfirm()">
                  <v-icon dark>mdi-delete</v-icon>
                  Deletar
                </v-btn>
                <v-spacer></v-spacer>
              </v-card-actions>
            </v-card>
          </v-dialog>
        </v-toolbar>
      </template>
      <!-- eslint-disable-next-line -->
      <template v-slot:item.type="{ item }">
        <v-icon dense left :color="getIconColor(item)">mdi-information</v-icon>
        {{ getType(item) }}
      </template>
      <!-- eslint-disable-next-line -->
      <template v-slot:item.actions="{ item }">
        <v-tooltip top color="blue darken-1">
          <!-- eslint-disable-next-line -->
          <template v-slot:activator="{ on, attrs }">
            <v-icon
              class="mr-2"
              color="blue darken-1"
              @click="editItem(item)"
              v-bind="attrs"
              v-on="on"
            >
              mdi-pencil
            </v-icon>
          </template>
          <span>Editar</span>
        </v-tooltip>
        <v-tooltip top color="red darken-1">
          <!-- eslint-disable-next-line -->
          <template v-slot:activator="{ on, attrs }">
            <v-icon
              color="red darken-1"
              @click="deleteItem(item)"
              v-bind="attrs"
              v-on="on"
            >
              mdi-delete
            </v-icon>
          </template>
          <span>Deletar</span>
        </v-tooltip>
      </template>
      <template v-slot:no-data>
        <v-btn color="primary" @click="getObservations()"> Recarregar </v-btn>
      </template>
    </v-data-table>
    <v-dialog v-model="dialogForm" max-width="650px">
      <v-card>
        <v-toolbar color="blue lighten-1" dark class="text-h5"
          >Observação do Pedido</v-toolbar
        >
        <v-card-text>
          <v-container fluid>
            <v-row>
              <v-col cols="12" xs="12" class="pb-2">
                <label class="text-subtitle-1"
                  >Selecione o tipo de obervação:</label
                >
              </v-col>
              <v-col cols="12" xs="12" md="12" class="py-0">
                <v-radio-group
                  v-model="observation.type"
                  column
                  class="mt-0"
                  dense
                >
                  <v-radio value="all">
                    <template v-slot:label>
                      <div>
                        <v-icon left color="green" dense
                          >mdi-information</v-icon
                        >
                        Todas as Empresas
                      </div>
                    </template>
                  </v-radio>
                  <v-radio value="type-company">
                    <template v-slot:label>
                      <div>
                        <v-icon left color="yellow darken-2" dense
                          >mdi-information</v-icon
                        >
                        Por Tipo de Empresa
                      </div>
                    </template>
                  </v-radio>
                  <v-radio value="company">
                    <template v-slot:label>
                      <div>
                        <v-icon left color="red lighten-1" dense
                          >mdi-information</v-icon
                        >
                        Empresa Específica
                      </div>
                    </template>
                  </v-radio>
                </v-radio-group>
              </v-col>
            </v-row>
            <v-row v-if="observation.type === 'company'">
              <v-col cols="12" xs="12" sm="12" md="8" lg="8">
                <v-autocomplete
                  :items="companies"
                  :item-text="(item) => `${item.code} - ${item.name}`"
                  item-value="id"
                  v-model="observation.company_id"
                  label="Empresa"
                  hide-details
                  dense
                  outlined
                ></v-autocomplete>
              </v-col>
            </v-row>
            <v-row v-if="observation.type === 'type-company'">
              <v-col cols="12" xs="12" sm="12" md="8" lg="8">
                <v-select
                  :items="company_types"
                  v-model="observation.company_type"
                  label="Tipo de Empresa"
                  dense
                  outlined
                  hide-details
                ></v-select>
              </v-col>
            </v-row>
            <v-row>
              <v-col>
                <v-textarea
                  label="Observação"
                  auto-grow
                  outlined
                  dense
                  rows="8"
                  row-height="12"
                  v-model="observation.observation"
                  class="text-field-uppercase"
                ></v-textarea>
              </v-col>
            </v-row>
            <alert
              :visible="!!errorObservation"
              dark
              type="error"
              :message="errorObservation"
              :clickClose="() => (errorObservation = '')"
            />
          </v-container>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" text @click="closeForm()">Fechar</v-btn>
          <v-btn color="blue darken-1" dark @click="formConfirm()">
            <v-icon dark left>mdi-check</v-icon>
            Salvar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { URL } from "@/api/config";

import * as CompanyAPI from "@/api/requests/CompanyRequest";

import Alert from "@/components/Alert";

export default {
  components: {
    Alert,
  },
  data: () => ({
    dialogDelete: false,
    dialogForm: false,
    search: "",
    loading: false,
    headers: [
      {
        text: "ID",
        align: "right",
        value: "id",
        width: 55,
      },
      { text: "Aparecerá para", value: "type", width: 200 },
      { text: "Observação", value: "observation", width: 400 },
      {
        text: "Ação",
        value: "actions",
        sortable: false,
        width: 100,
        align: "right",
      },
    ],
    observations: [],
    observation: {
      id: "",
      type: "all",
      company_id: "",
      company_type: "",
      observation: "",
    },
    defaultObservation: {
      id: "",
      type: "all",
      company_id: "",
      company_type: "",
      observation: "",
    },
    alert_message: "",
    type_alert: "",
    errorObservation: "",
    companies: [],
    company_types: [
      {
        value: "fra",
        text: "Franquias",
      },
      {
        value: "mul",
        text: "Multimarcas",
      },
    ],
  }),

  computed: {},

  watch: {
    dialogDelete(val) {
      val || this.closeDelete();
    },
    dialogForm(val) {
      val || this.closeForm();
    },
  },
  filters: {
    dateFormatBr: function (value) {
      return value.split("-").reverse().join("/");
    },
  },

  created() {
    this.initialize();
  },

  methods: {
    async initialize() {
      await this.getObservations();
      await this.getCompanies("fra,mul");
    },
    getColor(status) {
      return status == 1 ? "green" : "red";
    },
    getLabel(status) {
      return status == 1 ? "Ativo" : "Desativado";
    },

    async getObservations() {
      this.loading = true;
      this.observations = [];
      try {
        let response = await fetch(`${URL}order-observation`);
        this.observations = await response.json();
      } catch (error) {
        console.log(error);
      } finally {
        this.loading = false;
      }
    },
    async getCompanies(type) {
      this.loading = true;
      try {
        let data = await CompanyAPI.getAll(`?type=${type}`);
        this.companies = data.sort((a, b) => (a.code > b.code ? 1 : -1));
      } catch (error) {
        this.companies = [];
        console.log(error);
      } finally {
        this.loading = false;
      }
    },
    editItem(item) {
      console.log(item);
      this.observation = Object.assign({}, item);
      this.dialogForm = true;
      // this.$router.push({
      //   name: "ProviderPromotionsEdit",
      //   params: { id: item.id },
      // });
    },
    deleteItem(item) {
      // alert("A Implementar");
      this.observation = Object.assign({}, item);
      this.dialogDelete = true;
    },

    async deleteItemConfirm() {
      this.loading = true;
      this.closeDelete();
      try {
        let res = await fetch(
          `${URL}order-observation/${this.observation.id}`,
          {
            method: "DELETE",
          }
        );
        if (res.ok) {
          this.alert_message = "Observação deletada com sucesso";
          this.type_alert = "success";
          this.getObservations();
        }
      } catch (error) {
        this.alert_message = `Ocorreu um problema ao deletar esta Observação: ${error.message}`;
        this.type_alert = "error";
        console.log(error);
      } finally {
        this.loading = false;
      }
    },
    close() {
      this.dialog = false;
      this.$nextTick(() => {
        this.observation = Object.assign({}, this.defaultObservation);
      });
    },

    closeDelete() {
      this.dialogDelete = false;
      this.$nextTick(() => {
        this.observation = Object.assign({}, this.defaultObservation);
      });
    },
    addObservation() {
      this.dialogForm = true;
    },
    formConfirm() {
      this.errorObservation = "";
      if (this.validateForm()) {
        if (this.observation.type === "all") {
          this.observation.company_id = null;
          this.observation.company_type = null;
        } else if (this.observation.type === "company") {
          this.observation.company_type = null;
        } else if (this.observation.type === "type-company") {
          this.observation.company_id = null;
        }
        this.observation.observation =
          this.observation.observation.toUpperCase();
        this.dialogForm = false;
        if (this.observation.id !== "") {
          this.updateObservation(this.observation.id, this.observation);
        } else {
          this.createObservation(this.observation);
        }
      }
    },
    validateForm() {
      if (this.observation.observation === "") {
        this.errorObservation = "Preencha uma Observação para poder continuar";
        return false;
      }
      if (
        this.observation.type === "company" &&
        (this.observation.company_id == "" ||
          this.observation.company_id === null)
      ) {
        this.errorObservation = "Selecione uma Empresa para poder continuar";
        return false;
      }
      if (
        this.observation.type === "type-company" &&
        (this.observation.company_type == "" ||
          this.observation.company_type === null)
      ) {
        this.errorObservation =
          "Selecione um Tipo de Empresa para poder continuar";
        return false;
      }

      if (this.observation.type === "all") {
        let hasObservationCompany = this.observations.find(
          (item) => item.type === "all"
        );
        if (hasObservationCompany !== undefined) {
          if (
            hasObservationCompany.id !== this.observation.id ||
            this.observation.id === ""
          ) {
            this.errorObservation =
              "Já existe uma observação criada para todas as empresas";
            return false;
          }
        }
      }

      if (this.observation.type === "company") {
        let hasObservationCompany = this.observations.find(
          (item) => item.company_id === this.observation.company_id
        );
        if (hasObservationCompany !== undefined) {
          if (
            hasObservationCompany.id !== this.observation.id ||
            this.observation.id === ""
          ) {
            this.errorObservation =
              "Já existe uma observação criada para essa empresa";
            return false;
          }
        }
      }

      if (this.observation.type === "type-company") {
        let hasObservationCompany = this.observations.find(
          (item) => item.company_type === this.observation.company_type
        );
        if (hasObservationCompany !== undefined) {
          if (
            hasObservationCompany.id !== this.observation.id ||
            this.observation.id === ""
          ) {
            this.errorObservation =
              "Já existe uma observação criada para esse tipo de empresa";
            return false;
          }
        }
      }

      return true;
    },
    async createObservation(observation) {
      this.loading = true;
      try {
        let myHeaders = new Headers({
          "Content-Type": "application/json",
        });
        let res = await fetch(`${URL}order-observation`, {
          method: "POST",
          headers: myHeaders,
          body: JSON.stringify(observation),
        });
        if (res) {
          this.alert_message = "Observação salva com sucesso";
          this.type_alert = "success";
          this.errorObservation = "";
          this.getObservations();
        }
      } catch (error) {
        console.log(error);
        this.alert_message = `Ocorreu um problema ao salvar esta Observação: ${error.message}`;
        this.type_alert = "error";
      } finally {
        this.loading = false;
      }
    },
    async updateObservation(id, observation) {
      this.loading = true;
      try {
        let myHeaders = new Headers({
          "Content-Type": "application/json",
        });
        let res = await fetch(`${URL}order-observation/${id}`, {
          method: "PUT",
          headers: myHeaders,
          body: JSON.stringify(observation),
        });
        if (res) {
          this.alert_message = "Observação salva com sucesso";
          this.type_alert = "success";
          this.errorObservation = "";
          this.getObservations();
        }
      } catch (error) {
        console.log(error);
        this.alert_message = `Ocorreu um problema ao salvar esta Observação: ${error.message}`;
        this.type_alert = "error";
      } finally {
        this.loading = false;
      }
    },
    closeForm() {
      this.errorObservation = "";
      this.dialogForm = false;
      this.$nextTick(() => {
        this.observation = Object.assign({}, this.defaultObservation);
      });
    },
    getType(item) {
      if (item.type === "all") {
        return "Todas Empresas";
      } else if (item.type === "company") {
        return `Empresa: ${item.company.code} - ${item.company.name}`;
      } else if (item.type === "type-company") {
        if (item.company_type === "fra") {
          return "Todas as Franquias";
        }
        return "Todas as Multimarcas";
      }
    },
    getIconColor(item) {
      if (item.type === "all") {
        return "green";
      } else if (item.type === "company") {
        return "red lighten-1";
      }
      return "yellow darken-2";
    },
  },
};
</script>
<style>
.text-field-uppercase input,
.text-field-uppercase textarea {
  text-transform: uppercase;
}
</style>
